import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.neutralLighter,
    position: 'absolute',
    background: 'lightgreen',
    padding: 8,
    bottom: 0,
    right: 0,
    content: 'in portal',
  },
  rootSeparator: {
    // transition: 'background 0.3s',
  },
  separatorContainer: {
    cursor: 'pointer',
    visibility: 'visible',
    opacity: 1,
    width: '100%',
    minHeight: 10,
    // ':hover': {
    //   margin: '10px 0px',
    // },
  },
  buttonContainer: {
    // position: 'absolute',
    backgroundColor: theme.palette.themePrimary,
    height: 40,
    width: 40,
  },
  plusButton: {
    // top: '50%',
    // transform: 'translateY(-50%)',
    background: 'transparent',
    border: 'none',
    // color: '#3b82f6',
    // fontSize: '18px',
    // cursor: 'pointer',
    // display: 'none',
  },
  hiddenButton: {
    visibility: 'visible',
    opacity: 1,
    // transition: 'opacity 0.3s',
  },
  separator: {
    // transition: 'all 0.3s ease',
    cursor: 'pointer',
    width: '100%',
    // backgroundColor: theme.palette.white,
    height: 5,
  },
  separatorHovered: {
    cursor: 'pointer',
    width: '100%',
    borderRadius: 3,
    transition: 'all 0.3s ease',
    // backgroundColor: theme.palette.themePrimary,
    height: 5,
    ':hover': {
      backgroundColor: theme.palette.themePrimary,
      height: 50,

      // margin: '5px 0px',
    },
  },
}));
